"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormControl = require("../FormControl");
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _tss = require("../styles/tss");
var _responsiveProps = require("../utilities/responsiveProps");
const SelectIcon = function SelectIcon(props) {
  const {
    cx
  } = (0, _tss.useEmptyStyles)();
  const {
    classes = {},
    IconComponent,
    open = false
  } = props;
  const dsFormControl = (0, _FormControl.useFormControl)();
  const fcs = (0, _formControlState.default)({
    props,
    dsFormControl,
    states: ['disabled', 'error', 'focused', 'size']
  });
  const sizeClasses = (0, _responsiveProps.getResponsiveClassNamesForProp)(fcs.size || 'md', 'size').map(c => classes[c]);
  return /*#__PURE__*/_react.default.createElement(IconComponent, {
    className: cx(classes.icon, {
      [classes.iconOpen]: open,
      [classes.disabled]: fcs.disabled,
      [classes.error]: fcs.error,
      [classes.focused]: fcs.focused
    }, ...sizeClasses)
  });
};
var _default = exports.default = SelectIcon;